import { Component, inject, InjectionToken, OnInit, signal } from '@angular/core';
import { RouterLink } from '@angular/router';
import { ClerkAuthService } from '../../services/clerk-auth.service';
import { environment } from '../../../environments/environment';

/** Nom du JWT template Clerk longue duree (null hors environnement local). */
export const DEV_TOKEN_TEMPLATE = new InjectionToken<string | null>('DEV_TOKEN_TEMPLATE', {
  factory: () => environment.devTokenTemplate,
});

/**
 * Page de developpement (environnement local uniquement) : recupere un token
 * Clerk issu du JWT template longue duree et permet de le copier pour
 * appeler l'API depuis Bruno, Postman ou curl.
 */
@Component({
  imports: [RouterLink],
  selector: 'app-dev-token-page',
  styleUrl: './dev-token-page.scss',
  templateUrl: './dev-token-page.html',
})
export class DevTokenPage implements OnInit {
  private clerkAuthService = inject(ClerkAuthService);

  readonly template = inject(DEV_TOKEN_TEMPLATE);
  readonly token = signal<string | null>(null);
  readonly error = signal<string | null>(null);
  readonly loading = signal(false);
  readonly copied = signal(false);

  ngOnInit(): Promise<void> {
    return this.loadToken();
  }

  async loadToken(): Promise<void> {
    this.loading.set(true);
    this.error.set(null);
    this.copied.set(false);

    try {
      const token = await this.clerkAuthService.getToken(this.template ?? undefined);

      this.token.set(token);
      if (!token) {
        this.error.set('Aucune session Clerk active : connectez-vous puis réessayez.');
      }
    } catch (err) {
      this.token.set(null);
      this.error.set(
        `Impossible d'obtenir le token du template "${this.template}". ` +
          `Vérifiez qu'il existe dans l'instance de dev Clerk (${err instanceof Error ? err.message : err}).`,
      );
    } finally {
      this.loading.set(false);
    }
  }

  async copyToken(): Promise<void> {
    const token = this.token();

    if (!token) {
      return;
    }

    try {
      // Le token seul, sans le prefixe "Bearer ".
      await navigator.clipboard.writeText(token);
      this.copied.set(true);
    } catch {
      this.error.set('La copie dans le presse-papiers a échoué : sélectionnez le token manuellement.');
    }
  }
}
